import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.less']
})
export class GeneralComponent implements OnInit {

  items: Array<any> = [];
  constructor() {}
  ngOnInit() {}
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/general/general.component.ts